import { render, staticRenderFns } from "./CambiarCliente.vue?vue&type=template&id=d7232dc2&"
import script from "./CambiarCliente.vue?vue&type=script&lang=js&"
export * from "./CambiarCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports